import messaging from "@react-native-firebase/messaging";
import { checkNotifications, RESULTS } from "react-native-permissions";
import { isAndroid } from "./deviceDetectors";

const hasNotificationPermission = async () => {
  if (isAndroid) {
    const { status = "denied" } = await checkNotifications();

    return status === RESULTS.GRANTED;
  }

  const authorizationStatus = await messaging().hasPermission();

  return authorizationStatus === messaging?.AuthorizationStatus?.AUTHORIZED;
};

export default hasNotificationPermission;
